<template>
    <div v-if="startDate && endDate">
        <span v-if="!$moment(startDate).isSame(endDate, 'day')">
            <span class="text-nowrap">
                {{ $df($moment(startDate), showTimes ? 'dateTimeLongWeekday' : 'dateLongWeekday') }}
            </span>
            <span v-if="startDate && endDate">-</span>
            <span class="text-nowrap">
                {{ $df($moment(endDate), showTimes ? 'dateTimeLongWeekday' : 'dateLongWeekday') }}
            </span>
        </span>
        <span v-else>
            <span class="text-nowrap">
                {{ $df($moment(startDate), 'dateLongWeekday') + (showTimes ? ', ' : '') }}
            </span>
            <span
                v-if="showTimes"
                class="text-nowrap">
                <span v-if="openEnd">
                    {{ 'ab ' + $df($moment(startDate), 'time') }}
                </span>
                <span v-else>
                    {{ $df($moment(startDate), 'time') }}
                    -
                    {{ $df($moment(endDate), 'time') }}
                </span>
            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: "EventDate",
    props: {
        startDate: {
            type: String,
            required: true
        },
        endDate: {
            type: String,
            required: true
        },
        openEnd: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        showTimes() {
            return this.dateTimeHasTime(this.startDate) || this.dateTimeHasTime(this.endDate)
        }
    },
    methods: {
        dateTimeHasTime(dateTime) {
            const dateMoment = this.$moment(dateTime)
            return !(dateMoment.hour() === 0 && dateMoment.minute() === 0 && dateMoment.second() === 0)
        }
    }
}
</script>

<style scoped>

</style>
